import React, { useEffect, useRef } from "react";
import { useLanderConfig } from "../../commons/ConfigContext";
import { AdContent } from "../AdContent";
import { Banner } from "../cashparking/Banner";
import { ModernFooter } from "./ModernFooter";
import { ModernArrows } from "./ModernArrows";
import { ChevronIndicators } from "./ChevronIndicators";
import classes from "./ModernLayout.module.scss";

export function ModernLayout() {
  const { landerConfig, queryConfig } = useLanderConfig();
  const layoutRef = useRef<HTMLDivElement>(null);

  const domainName =
    landerConfig.lander.domainDisplayName || landerConfig.domain.rootDomain;
  const isAdsPage = "qs" in queryConfig;

  useEffect(() => {
    const cssVar = layoutRef.current
      ? getComputedStyle(layoutRef.current)
          .getPropertyValue("--modern-dark-bg")
          .trim()
      : "";
    const bg = cssVar || "#0e1e26";
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = bg;
    return () => {
      document.body.style.backgroundColor = prev;
    };
  }, []);

  return (
    <div
      ref={ layoutRef }
      className={ classes.modernLayout }
      data-testid="modernLayout"
    >
      <div className={ classes.modernBanner } data-testid="modernBanner">
        <Banner landerConfig={ landerConfig } queryConfig={ queryConfig } />
      </div>

      {!isAdsPage && (
        <div className={ classes.domainSection }>
          <h1 className={ classes.domainName }>{domainName}</h1>
          <ChevronIndicators />
        </div>
      )}

      <div
        className={ `${classes.contentSection}${
          isAdsPage ? ` ${classes.adsPageContent}` : ""
        }` }
      >
        <div className={ classes.arrowsContainer }>
          <ModernArrows side="left" />
        </div>
        <div className={ classes.adContainer }>
          <AdContent
            maxAds={ 3 }
            maxRS={ 5 }
            adIcon={ <span style={{ fontSize: "1.1rem" }}>&#9658;</span> }
            headerMessageId="Yahoo-RelatedSearches"
          />
        </div>
        <div className={ classes.arrowsContainer }>
          <ModernArrows side="right" />
        </div>
      </div>

      <ModernFooter />
    </div>
  );
}
